import styled from "@emotion/styled"

const HeroScrollCaseItemContainer = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 128px;
  flex-wrap: wrap;

  ${({ theme }) => theme.breakpoints.up("3xl")} {
    padding-left: 150px;
  }

  ${({ theme }) => theme.breakpoints.down("3xl")} {
    padding-left: 120px;
  }

  ${({ theme }) => theme.breakpoints.down("2xl")} {
    padding-left: 96px;
  }

  ${({ theme }) => theme.breakpoints.down("xl")} {
    padding-left: 10%;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    padding: 0 48px;
  }

  ${({ theme }) => theme.breakpoints.down("sm")} {
    padding: 0 16px;
  }
`

export default HeroScrollCaseItemContainer
